import React, { useContext, useEffect, useState } from 'react';
import {
  FamilyReferencesDropdown,
  FamilyReferencesDropdownHeader,
  FamilyReferencesDropdownBody
} from './styles';
import { default as ReferencesTypes } from '../../../store/References/types';
import FormTemplate from '../../../components/FormTemplate';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import Alert from '../../../components/Alert';
import { Controller, useForm } from 'react-hook-form';
import { BsCheck, BsChevronDown } from 'react-icons/bs';
import { ReferencesContext } from '../../../store';
import InputDefault from '../../../components/InputDefault';
import ModalAction from '../../../components/ModalAction';
import InputPhone from '../../../components/InputPhone';
import Select from '../../../components/Select';
import { familyRelationShip } from '../../../helpers/enum';
import SearchField from '../../../components/SearchField';
import { getStates } from '../../../services/states';
import { getCities } from '../../../services/cities';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { referencesSteps } from '../../../helpers/enum';
import { postReferences } from '../../../services/references';
import { useHistory, useLocation } from 'react-router-dom';
import colors from '../../../assets/styles/colors';
import Loader from '../../../components/Loader';

const FamilyReferencesPage = ({ setActiveStep, setLastStep }) => {
  const location = useLocation();
  const history = useHistory();
  const { references, setReferences } = useContext(ReferencesContext);
  const { control, setValue, clearErrors, register, handleSubmit, errors, watch } = useForm({ defaultValues: references.family });
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [states, setStates] = useState([]);
  const [showFirstFamilyDropDown, setShowFirstFamilyDropDown] = useState(false);
  const [showFirstRelacionship, setShowFirstRelationship] = useState(false);
  const [showFirstState, setShowFirstState] = useState(false);
  const [showFirstCity, setShowFirstCity] = useState(false);
  const [firstCities, setFirstCities] = useState([]);
  const [showSecondFamilyDropDown, setShowSecondFamilyDropDown] = useState(false);
  const [showSecondRelacionship, setShowSecondRelationship] = useState(false);
  const [showSecondState, setShowSecondState] = useState(false);
  const [showSecondCity, setShowSecondCity] = useState(false);
  const [secondCities, setSecondCities] = useState([]);
  const [filteredFirstCities, setFilteredFirstCities] = useState([]);
  const [filteredFirstStates, setFilteredFirstStates] = useState([]);
  const [filteredSecondCities, setFilteredSecondCities] = useState([]);
  const [filteredSecondStates, setFilteredSecondStates] = useState([]);

  const fields = watch();

  async function setCompleteStep(data) {
    try {
      setIsLoading(true);

      const req = [
        {
          idCredito: location.idCredit,
          primerNombre: references.personal.first.firstPrimerNombre || '',
          segundoNombre: references.personal.first.firstSegundoNombre || '',
          primerApellido: references.personal.first.firstPrimerApellido || '',
          segundoAPellido: references.personal.first.firstSegundoApellido || '',
          relacion: references.personal.first.relationship?.id,
          telefonoCelular: references.personal.first.firstCelular?.replaceAll(' ', ''),
          departamentoTrabajo:  "CO>Indefinido>Indefinido",
          ciudadTrabajo: "CO>Indefinido>Indefinido",
          tipoReferencia: 'PERSONAL'
        },
        {
          idCredito: location.idCredit,
          primerNombre: data.firstPrimerNombre || '',
          segundoNombre: data.firstSegundoNombre || '',
          primerApellido: data.firstPrimerApellido || '',
          segundoAPellido: data.firstSegundoApellido || '',
          relacion: references.family.first.relationship?.id || '',
          telefonoCelular: data.firstCelular || '',
          departamentoTrabajo:  "CO>Indefinido>Indefinido",
          ciudadTrabajo: "CO>Indefinido>Indefinido",
          tipoReferencia: 'FAMILIAR'
        },
      ]

      await postReferences(req);
      setIsLoading(false);
      setShowSuccessModal(true);
    } catch (error) {
      console.log(error.response)
      console.log(error)
    }
  }

  async function initializedStateComponent() {
    try {
      setValue('firstState', "CO>Indefinido");

      setValue('firstCity', "CO>Indefinido>Indefinido");

      setValue('secondState', "CO>Indefinido");

      setValue('secondCity', "CO>Indefinido>Indefinido");

      if (references.family.first.firstPrimerNombre) {
        setValue('firstPrimerNombre', references.family.first.firstPrimerNombre)
      }

      if (references.family.first.firstSegundoNombre) {
        setValue('firstSegundoNombre', references.family.first.firstSegundoNombre)
      }

      if (references.family.first.firstPrimerApellido) {
        setValue('firstPrimerApellido', references.family.first.firstPrimerApellido)
      }

      if (references.family.first.firstSegundoApellido) {
        setValue('firstSegundoApellido', references.family.first.firstSegundoApellido)
      }

      if (references.family.first.relationship) {
        setValue('firstRelacion', references.family.first?.relationship.nombre)
      }

      if (references.family.first.firstCelular) {
        setValue('firstCelular', references.family.first.firstCelular)
      }

      if (references.family.second.secondPrimerNombre) {
        setValue('secondPrimerNombre', references.family.second.secondPrimerNombre)
      }

      if (references.family.second.secondSegundoNombre) {
        setValue('secondSegundoNombre', references.family.second.secondSegundoNombre)
      }

      if (references.family.second.secondPrimerApellido) {
        setValue('secondPrimerApellido', references.family.second.secondPrimerApellido)
      }

      if (references.family.second.secondSegundoApellido) {
        setValue('secondSegundoApellido', references.family.second.secondSegundoApellido)
      }

      if (references.family.second.relationship) {
        setValue('secondRelacion', references.family.second?.relationship.nombre)
      }

      if (references.family.second.secondCelular) {
        setValue('secondCelular', references.family.second.secondCelular)
      }

      const states = await getStates();
      setStates(states.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      console.log(error.response)
    }
  }

  function setSelectedFirstRelationship(relationship) {
    setReferences({
      type: ReferencesTypes.SET_SELECTED_FAMILY_FIRST_RELATIONSHIP,
      relationship
    })
  }

  function setSelectedSecondRelationship(relationship) {
    setReferences({
      type: ReferencesTypes.SET_SELECTED_FAMILY_SECOND_RELATIONSHIP,
      relationship
    })
  }

  function setBackStep() {
    setReferences({
      type: ReferencesTypes.SET_FAMILY,
      family: {
        ...references.family,
        first: {
          ...references.family.first,
          firstPrimerNombre: fields.firstPrimerNombre,
          firstSegundoNombre: fields.firstSegundoNombre,
          firstPrimerApellido: fields.firstPrimerApellido,
          firstSegundoApellido: fields.firstSegundoApellido,
          firstCelular: fields.firstCelular,
        },
        second: {
          ...references.family.first,
         secondPrimerNombre: fields.secondPrimerNombre,
         secondSegundoNombre: fields.secondSegundoNombre,
         secondPrimerApellido: fields.secondPrimerApellido,
         secondSegundoApellido: fields.secondSegundoApellido,
         secondCelular: fields.secondCelular,
        }
      }
    })

    setActiveStep(referencesSteps.PERSONAL);
  }
  
  useEffect(() => {
    initializedStateComponent();
  }, [])

  return (
    <FormTemplate 
      idForm="family-references-step-lage"
      activeStep="2/2"
      stepLabel="Referencias familiares">
      <Alert 
        default
        description="Importante la confirmación de las referencias por parte del cliente, para que el proceso de validación sea más eficiente."
      />
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        <FamilyReferencesDropdown open={showFirstFamilyDropDown} >
          <FamilyReferencesDropdownHeader onClick={() => setShowFirstFamilyDropDown(!showFirstFamilyDropDown)}>
            Referencia familiar 1
            <BsChevronDown size={22} />
          </FamilyReferencesDropdownHeader>
          <FamilyReferencesDropdownBody>
            <FormRow col="2">
              <Controller
                as={InputDefault}
                control={control}
                label="Primer Nombre"
                name="firstPrimerNombre"
                register={register({ 
                  validate: {
                    required: value => {
                      if (!value) {
                        setShowFirstFamilyDropDown(true);
                        return "Este dato es obligatorio";
                      }
                        
                      return true;
                    }
                  },
                 })}
                id="firstPrimerNombre"
                error={errors.firstPrimerNombre}
                value={references.family.first.firstPrimerNombre} />
              <Controller
                as={InputDefault}
                control={control}
                label="Segundo Nombre"
                name="firstSegundoNombre"
                register={register}
                id="firstSegundoNombre"
                value={references.family.first.firstSegundoNombre} />
            </FormRow>
            <FormRow col="2">
              <Controller
                as={InputDefault}
                control={control}
                label="Primer apellido"
                name="firstPrimerApellido"
                register={register({ 
                  validate: {
                    required: value => {
                      if (!value) {
                        setShowFirstFamilyDropDown(true);
                        return "Este dato es obligatorio";
                      }
                        
                      return true;
                    }
                  },
                 })}
                id="firstPrimerApellido"
                error={errors.firstPrimerApellido}
                value={references.family.first.firstPrimerApellido} />
              <Controller
                as={InputDefault}
                control={control}
                label="Segundo Apellido"
                name="firstSegundoApellido"
                register={register}
                id="firstSegundoApellido"
                value={references.family.first.firstSegundoApellido} />
            </FormRow>
            <FormRow col="2">
              <Select
                setShow={setShowFirstRelationship}
                show={showFirstRelacionship}
                defaultValue={references.family.first.relationship?.nombre}
                setSelected={setSelectedFirstRelationship}
                list={familyRelationShip}
                placeholder="Seleccionar..."
                label="Relación"
                name="relacion"
                id="relacion"
                error={errors.relacion}
                register={register({ 
                  validate: {
                    required: value => {
                      if (!value) {
                        setShowFirstFamilyDropDown(true);
                        return "Este dato es obligatorio";
                      }
                        
                      return true;
                    }
                  },
                 })} />
              <Controller
                as={InputPhone}
                control={control}
                label="Celular"
                name="firstCelular"
                error={errors.firstCelular}
                register={register({
                  validate: {
                    required: value => {
                      if (!value) {
                        setShowFirstFamilyDropDown(true);
                        return "Este dato es obligatorio";
                      }
                        
                      return true;
                    }
                  },
                  pattern: {
                    value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                    message: "Error en el número, ingresa uno válido",
                  },
                })}
                id="firstCelular"
                mask="999 999 99 99"
                value={references.family.first.firstCelular} />
            </FormRow>
          </FamilyReferencesDropdownBody>
        </FamilyReferencesDropdown>
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" onClick={() => setBackStep()}>Volver</DefaultLargeButton>
          <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
        </FormFooter>
        {isLoading && <Loader/>}
      </Form>

      <ModalAction
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionUpButton={() => history.push({
          pathname: '/admin/life-insurance',
          idCredit: location.idCredit
        })}
        title="¡Felicitaciones!"
        actionLabelFunctionUpButton="Continuar"
        description="La información del cliente ha sido registrada exitosamente, continua con el proceso de crédito."
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
    </FormTemplate>
  )
}

export default FamilyReferencesPage;
